var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "upload",
          attrs: {
            model: _vm.uploadForm,
            rules: _vm.rules,
            "label-width": "120px",
            "label-position": "right",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { prop: "files", label: "选择文件" } },
            [
              _c(
                "el-upload",
                {
                  ref: "upload",
                  attrs: {
                    name: "file",
                    "on-change": _vm.handleChange,
                    action: "",
                    "http-request": _vm.httpRequest,
                    "on-remove": _vm.removeList,
                  },
                },
                [
                  _c(
                    "el-input",
                    {
                      staticStyle: { width: "200px" },
                      attrs: { readonly: "" },
                    },
                    [
                      _c("el-button", {
                        attrs: { slot: "append", icon: "el-icon-search" },
                        slot: "append",
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { prop: "docComments", label: "文件描述" } },
            [
              _c("el-input", {
                staticStyle: { width: "200px" },
                attrs: {
                  placeholder: "",
                  type: "textarea",
                  maxlength: "100",
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.uploadForm.docComments,
                  callback: function ($$v) {
                    _vm.$set(_vm.uploadForm, "docComments", $$v)
                  },
                  expression: "uploadForm.docComments",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.uploading("ruleForm")
                    },
                  },
                },
                [_vm._v("上传")]
              ),
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取消")]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }